/*
 * @Author: heyouqin@moyi365.com
 * @LastEditors: heyouqin@moyi365.com
 * @Date: 2024-01-30 14:09:05
 * @LastEditTime: 2024-03-05 16:11:28
 * @Descripttion: file content
 */
import React, {ReactNode, useEffect, useState} from 'react'
import {Root} from 'react-dom/client'
import style from './index.module.scss'
import render2Body from '@/utils/render2Body'
import Event from '@/utils/Event'
import remove2Body from '@/utils/removeBody'
import {CloseOutlined} from '@ant-design/icons'

interface AlertBaseProp {
	mask?: boolean
}

interface AlertCoreProp {
	type: 'core'
	title: string
	children: ReactNode
}

// export interface BtnList {
// 	/**
// 	 * 行为，jump：跳转行为；cancel：取消行为l；confirm：确认行为
// 	 */
// 	action: string

// 	/**
// 	 * 跳转时才需要该数据, 因后端传输问题，定义为 json 字符串 {"data":{},"router":""}
// 	 */
// 	jump_data?: string

// 	/**
// 	 * 按钮文本
// 	 */
// 	text: string
// }
interface AlertToastProp {
	type: 'toast'
	title?: string
	subTitle?: string
	cancelText?: string
	confirmText?: string
	// btn_list?: BtnList[]
	confirmCallback?: () => void
	cancelCallback?: () => void
}

interface AlertMsgProp {
	type?: 'msg'
	children: ReactNode
}

type AlertProps = AlertBaseProp & (AlertCoreProp | AlertMsgProp | AlertToastProp)

type InternalAlertProps<T> = AlertProps & {visible: boolean; hide: () => void} & T

const event = new Event()

let root: Root | null = null
const ID = 'alert-root'

const InternalAlertMsg = ({children, mask, visible}: InternalAlertProps<{type: 'msg'}>) => {
	return (
		<div className={style.alert}>
			<div className={[style.alertContainer, visible ? style.alertContainerIn : style.alertContainerOut].join(' ')}>
				{children}
			</div>
			{mask && <div className={[style.alertMask, visible ? style.alertMaskIn : style.alertMaskOut].join(' ')} />}
		</div>
	)
}

const InternalAlertToast = ({
	mask = true,
	visible,
	title,
	subTitle,
	cancelText,
	confirmText,
	// btn_list,
	confirmCallback,
	cancelCallback,
	hide
}: InternalAlertProps<{type: 'toast'}>) => {
	const cancel = () => {
		hide()
		cancelCallback && cancelCallback()
	}
	const confirm = () => {
		hide()
		confirmCallback && confirmCallback()
	}
	return (
		<div className={style.alert}>
			<div className={[style.alertContainer, visible ? style.alertContainerIn : style.alertContainerOut].join(' ')}>
				<div className={style.toast}>
					{title && <div className={style.toastTitle}>{title}</div>}
					{subTitle && <div className={style.toastContent}>{subTitle}</div>}
					<div className={style.toastBtn} style={{display: 'flex'}}>
						{cancelText && (
							<button className={style.toastRestartButton} onClick={cancel}>
								{cancelText}
							</button>
						)}
						{confirmText && (
							<button className={style.toastContinueButton} onClick={confirm}>
								{confirmText}
							</button>
						)}
					</div>
				</div>
			</div>
			{mask && <div className={[style.alertMask, visible ? style.alertMaskIn : style.alertMaskOut].join(' ')} />}
		</div>
	)
}

const InternalAlertCore = ({children, mask = true, visible, hide, title}: InternalAlertProps<{type: 'core'}>) => {
	return (
		<div className={style.alert}>
			<div
				className={[
					style.alertContainer,
					style.coreContainer,
					visible ? style.alertContainerIn : style.alertContainerOut
				].join(' ')}
			>
				<div className={style.header}>
					<span>{title}</span>
					<div className={style.close} onClick={() => hide()}>
						<CloseOutlined />
					</div>
				</div>
				<div className={style.content}>{children}</div>
			</div>
			{mask && <div className={[style.alertMask, visible ? style.alertMaskIn : style.alertMaskOut].join(' ')} />}
		</div>
	)
}

const InternalAlert = (props: AlertProps) => {
	const [visible, setVisible] = useState(true)

	useEffect(() => {
		event.on('hide', () => {
			setVisible(false)
			setTimeout(() => {
				root?.unmount()
				remove2Body(ID)
			}, 200)
		})
		return () => {
			event.off('hide')
		}
	}, [])

	let Component: (props: InternalAlertProps<any>) => React.JSX.Element = () => <div></div>

	if (props.type === 'msg') {
		Component = InternalAlertMsg
	} else if (props.type === 'core') {
		Component = InternalAlertCore
	} else if (props.type === 'toast') {
		Component = InternalAlertToast
	}
	return <Component {...props} visible={visible} hide={() => event.emit('hide')} />
}

function show(options: AlertProps) {
	root = render2Body(ID, <InternalAlert {...options} />)
}

const hide = () => {
	event.emit('hide')
}

export default {
	show,
	hide
}
